jQuery(function($){
  let basketItems = getBasket();

  renderBasketItems(basketItems);

  $(document).on('click', '.basket-checkout', function() {
    let items = '';
    $.each(basketItems, function(key, variant) {
      // Add column prefix if there's already item before this iteration
      items += items ? ',' : '';
      items += key + ':' + variant.qty;
    });

    window.location.href = basket.shopurl + '/cart/' + items;
    // setTimeout(function(){
    // }, 300);

    // Clear basket after passing it to shopify
    // localStorage.removeItem('basket');
    // basketItems = {};
  });

  $(document).on('click', '.remove-basket-item', function(e) {
    let target = $(this).parents('.cart__item');
    const basketItemId = target.data('cart-id');
    let basketItems = getBasket();

    // remove basket item here
    delete basketItems[basketItemId];
    localStorage.setItem('basket', JSON.stringify(basketItems));

    target.remove();
    renderBasketItems(basketItems);
    e.preventDefault();
  });

  $(document).on('click', '.card__item--product .card__image', function() {
    $(this).find('.remove-basket-item').css('visibility', 'visible');
  });

});

function getBasket() {
  let basketItems = localStorage.getItem('basket') ? JSON.parse(localStorage.getItem('basket')) : {};

  return basketItems;
}

function renderBasketItems(basketItems) {
  let items = '';
  let total_price = 0;
  $.each(basketItems, function(key, variant) {
    let { product, title, thumbnail, price } = variant;

    total_price += parseFloat( price );
    $('.cart-total-amount').html( '£' + total_price );

    items += `<div class="col-6 col-md-6 col-lg-3 cart__item" data-cart-id="${key}">
                <div class="card__item card__item--product">
                  <div class="card__image">
                    <img src="${thumbnail}" alt="" class="img-fluid" />
                    <a href="#" class="remove-basket-item"><i class="fa fa-close"></i></a>
                  </div>
                  <div class="card__body">
                    <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-12 col-md-9">
                              <h3 class="card__title">${product}</h3>
                            </div>
                            <div class="col-12 col-md col-price">
                              <span class="card__price">£${price}</span>
                            </div>
                            <div class="col-12">
                              <div class="card__size"><span>Size</span> <strong>${title}</strong></div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>`;
  });

  // Display basket details by default
  $('.basket__details').show();
  if ( !items ) {
    // Initialize no items text
    items = '<div class="col-md-12">You have no items in your basket.</div>';
    // Hide basket details
    $('.basket__details').hide();
  }

  // Render basket items
  $('#basketItems').html(items);

  // Display basket count
  getBasketCount();
}

// TODO refactor this and merge it to store.js function
function getBasketCount() {
  let basketItems = localStorage.getItem('basket') ? JSON.parse(localStorage.getItem('basket')) : {};
  let basketCount = Object.keys(basketItems).length;
  $('.basket__count').html( basketCount );
}
